import { render, staticRenderFns } from "./Covid-19.vue?vue&type=template&id=6744c6b9"
import script from "./Covid-19.vue?vue&type=script&lang=js"
export * from "./Covid-19.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports